// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3TWmQ","inquiryform":"styles_inquiryform__1Dy7q","item":"styles_item__1AXy9"};